import { render, staticRenderFns } from "./ChatLog.vue?vue&type=template&id=9f2a2852"
import script from "./ChatLog.vue?vue&type=script&lang=js"
export * from "./ChatLog.vue?vue&type=script&lang=js"
import style0 from "./ChatLog.vue?vue&type=style&index=0&id=9f2a2852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports